import clsx from 'clsx';
import type { FC } from 'react';

interface ChatModeProps {
  selectedMode: 'platform' | 'agent';
  onModeChange: (mode: 'platform' | 'agent') => void;
}

const MODES: { id: 'platform' | 'agent'; text: string }[] = [
  { id: 'platform', text: 'Knowledge' },
  { id: 'agent', text: 'Agent' },
];

/**
 * Compact pill toggle for the AI chat side panel — switches between the
 * platform-knowledge chat and the read-only RiskSmart Agent. Replaces the
 * heavier Cloudscape SegmentedControl, whose segment buttons the AI header's
 * 40×40 icon-button styling squashed. The `!`-prefixed utilities deliberately
 * override that inherited sizing for these text segments. The parent gates
 * rendering on the `ai.subModules.agent` entitlement. (Temporary — this control
 * goes away once the two modes are combined.)
 */
export const ChatMode: FC<ChatModeProps> = ({ selectedMode, onModeChange }) => (
  <div
    role={'group'}
    aria-label={'Chat mode'}
    className={'inline-flex items-center gap-1 rounded-full bg-grey150 p-1'}
  >
    {MODES.map((mode) => {
      const selected = mode.id === selectedMode;

      return (
        <button
          key={mode.id}
          type={'button'}
          aria-pressed={selected}
          onClick={() => onModeChange(mode.id)}
          className={clsx(
            '!h-auto !w-auto !rounded-full !px-3 !py-1 text-xs font-semibold transition-colors',
            selected
              ? '!bg-teal !text-navy shadow-sm hover:!bg-teal'
              : '!bg-transparent'
          )}
        >
          {mode.text}
        </button>
      );
    })}
  </div>
);
